import script from "./AdminProductTableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductTableActions.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductTableActions.vue?vue&type=style&index=0&id=9a2f3b24&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2f3b24"]])

export default __exports__